import React, { useState, useEffect } from 'react';
import {
    TextField,
    Button,
    Typography,
    Grid,
    Switch,
    MenuItem,
    Modal,
    Box,
    IconButton,
    Paper,
    Snackbar,
    Select
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../../config/config.js';
var constants = require('../../constant');

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

const AddDocument = ({ onClose, editMode = false, documentData = {} }) => {

    const operationsUrl = config.operationsUrl;
    const clientId = localStorage.getItem('clientId');
    const token = localStorage.getItem('token');
    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    const [documentId, setDocumentId] = useState('');
    const [documentName, setDocumentName] = useState('');
    const [city, setCity] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [noOfImages, setNoOfImages] = useState('');
    const [expiredAction, setExpiredAction] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [galleryRestricted, setGalleryRestricted] = useState(false);
    const [documentRequired, setDocumentRequired] = useState(false);
    const [documentNumRequired,setDocumentNumRequired] = useState(false);
    const [docExpiryRequired,setDocExpiryRequired] = useState(false);

    const [statusFilter, setStatusFilter] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const navigate = useNavigate();

    // Populate form fields in edit mode
    useEffect(() => {
        console.log('Populating fields with:', documentData);
        if (editMode && documentData) {
            setDocumentId(documentData.document_id || '');
            setDocumentName(documentData.document_name || '');
            setCity(documentData.city_name || '');
            // Convert the document_type ID to its corresponding name
            setDocumentType(constants.DocumentTypes[documentData.document_type] || '');
            setNoOfImages(documentData.no_of_images || '');
            setIsActive(documentData.is_active === 1);
            setGalleryRestricted(documentData.is_gallery_restricted === 1);
            setDocumentRequired(documentData.is_required === 1);
            setDocumentNumRequired(documentData.is_doc_number_required===1);
            setDocExpiryRequired(documentData.is_doc_expired===1);
            setExpiredAction(documentData.expired_action);
        } else {
            // Reset fields in add mode
            resetFormFields();
        }
    }, [editMode, documentData]);

    // Function to reset form fields
    const resetFormFields = () => {
        setDocumentId('');
        setDocumentName('');
        setExpiredAction('');
        setCity('');
        setDocumentType('');
        setNoOfImages('');
        setIsActive(true);
        setGalleryRestricted(false);
    };
    
    // Function to handle saving the document
    const handleSubmit = async () => {
        const token = localStorage.getItem('token');
        // Find the key (numeric ID) corresponding to the selected document type label
        const documentTypeId = parseInt(
            Object.entries(constants.DocumentTypes).find(([_, value]) => value === documentType)?.[0] || 0
        );

        const ctId = clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || null;
        localStorage.setItem('ctId', ctId);

        if(noOfImages > 2){
            setSnackbarMessage('The number of images must be either 1 or 2.');
            setOpenSnackbar(true);
            return;
        }
        if(expiredAction==''){
            setSnackbarMessage('Please select an expired action');
            setOpenSnackbar(true);
            return;
        }

        const payload = {
            token: token,
            document_name: documentName,
            document_type: documentTypeId,
            city_id: clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || null,
            client_id: parseInt(clientId),
            no_of_images: parseInt(noOfImages) || 0,
            is_gallery_restricted: galleryRestricted ? 1 : 0,
            is_active: isActive ? 1 : 0,
            is_required: documentRequired ? 1 : 0,
            is_doc_number_required: documentNumRequired ? 1 : 0,
            is_doc_expired: docExpiryRequired ? 1 : 0,
            expired_action: expiredAction
        };

        // Include `document_id` in the payload if in edit mode
        if (editMode && documentId) {
            payload.document_id = documentId;
        }

        // Validation: Ensure all required fields are filled
        if(!payload.document_name){
            setSnackbarMessage('Document name is required');
            setOpenSnackbar(true);
            return;
        }
        if(!payload.document_type){
            setSnackbarMessage('Document type is required');
            setOpenSnackbar(true);
            return;
        }
        if(!payload.city_id){
            setSnackbarMessage('City is required');
            setOpenSnackbar(true);
            return;
        }
        if(!payload.no_of_images){
            setSnackbarMessage('No of images is required');
            setOpenSnackbar(true);
            return;
        }

        try {
            const url = operationsUrl + '/create_and_update_driver_docs';
            var response = await axios.post(url, payload);

            if(response.data.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }

            if (response.data.flag === 200) {
                console.log('Document saved successfully:', response.data.message);
                localStorage.setItem('saveCityIdDriverDoc', clientCities.find((cityObj) => cityObj.city_name === city)?.city_id || '');
                window.location.reload();
            } else {
                console.error('Failed to save document:', response.data.message);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
        }

        onClose(); // Close the modal after saving
    };

    // Reset the form fields
    const handleReset = () => {
        resetFormFields();
    };
    
    return (
        <div style={{ position: 'relative', padding: '40px 0' }}>
            {/* Close Button Outside the Card */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                style={{
                    position: 'absolute',
                    top: '-15px', // Position it above the Paper component
                    left: '1px',
                    color: '#333',
                    zIndex: 10,
                }}
            >
                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
        </IconButton>

            {/* Main Card/Container */}
            <Paper
                elevation={3}
                style={{
                    padding: '30px',
                    maxWidth: '800px',
                    margin: '0 auto',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '12px',
                }}
            >

            {/* Document Section */}
            {editMode && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#fff',
                    padding: '10px 20px',
                    border: '1px solid #E0E0E0',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                    marginBottom: '20px',
                    marginTop: '50px',
                }}>
                    <Typography variant="body1" style={{ color: '#4A4A4A' }}>
                        Document
                    </Typography>
                    <div style={{ display: 'flex', marginLeft: 'auto' }}>
                    <Button
                        variant="contained"
                        onClick={() => setIsActive(true)} // Fixed: Use setIsActive
                        style={{
                            backgroundColor: isActive ? '#0DBA78' : '#F4F4F4', // Fixed: Use isActive
                            color: isActive ? '#FFFFFF' : '#9E9E9E',
                            textTransform: 'none',
                            borderRadius: '8px 0 0 8px', // Rounded on the left side
                            boxShadow: 'none',
                            padding: '6px 16px',
                            minWidth: '80px',
                        }}
                    >
                        Enable
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => setIsActive(false)} // Fixed: Use setIsActive
                        style={{
                            backgroundColor: !isActive ? '#D14545' : '#F4F4F4', // Fixed: Use isActive
                            color: !isActive ? '#FFFFFF' : '#9E9E9E',
                            textTransform: 'none',
                            borderRadius: '0 8px 8px 0', // Rounded on the right side
                            boxShadow: 'none',
                            padding: '6px 16px',
                            minWidth: '80px',
                        }}
                    >
                        Disable
                    </Button>
                </div>
                </div>
            )}

            {/* Heading */}
            <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
            {editMode ? 'Edit Driver Document' : 'Add Driver Document'}
            </Typography>

            {/* Input Fields */}
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label={<span>City <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Select City"
                        select
                        fullWidth
                        variant="outlined"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        disabled={editMode}
                        InputProps={{
                            style: {
                                height: '56px',
                                fontSize: '16px',
                                padding: '8px 14px',
                                backgroundColor: '#FFFFFF',
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#E0E0E0',
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '16px',
                            },
                        }}
                    >
                    {clientCities.map((cityObj) => (
                            <MenuItem key={cityObj.city_id} value={cityObj.city_name}>
                                {cityObj.city_name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <TextField
                        label={<span>Document Name <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Enter Document Name"
                        fullWidth
                        variant="outlined"
                        value={documentName}
                        onChange={(e) => setDocumentName(e.target.value)}
                        InputProps={{
                            style: {
                                height: '56px',
                                fontSize: '16px',
                                padding: '8px 14px',
                                backgroundColor: '#FFFFFF',
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#E0E0E0',
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '16px',
                            },
                        }}
                    />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <TextField
                        label={<span>Document Type <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Select Document Type"
                        select
                        fullWidth
                        variant="outlined"
                        value={documentType}
                        onChange={(e) => setDocumentType(e.target.value)}
                        InputProps={{
                            style: {
                                height: '56px',
                                fontSize: '16px',
                                padding: '8px 14px',
                                backgroundColor: '#FFFFFF',
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#E0E0E0',
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '16px',
                            },
                        }}
                    >
                        {Object.entries(constants.DocumentTypes).map(([id, label]) => (
                            <MenuItem key={id} value={label}>
                                {label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <TextField
                        label={<span> Number Of Images <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Enter Number Of Images"
                        fullWidth
                        variant="outlined"
                        type="number"
                        value={noOfImages}
                        onChange={(e) => setNoOfImages(e.target.value)}
                        InputProps={{
                            inputProps: { min: 0 }, // Prevent values less than zero
                            style: {
                                height: '56px',
                                fontSize: '16px',
                                padding: '8px 14px',
                                backgroundColor: '#FFFFFF',
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#E0E0E0',
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '16px',
                            },
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Typography sx={{}}>Expired action</Typography>
                    <Select value={expiredAction} onChange={(e) => setExpiredAction(e.target.value)} fullWidth
                        sx={{
                            height: '50px', borderRadius:'8px'
                        }}
                    >
                        <MenuItem value="">Select</MenuItem>
                        <MenuItem value="1">Block</MenuItem>
                        <MenuItem value="2">Warning</MenuItem>
                    </Select>
                </Grid>

                {/* Gallery Restricted Switch */}
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px 20px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '8px',
                            backgroundColor: '#FFFFFF',
                        }}
                    >
                        <Typography
                            variant="body1"
                            style={{
                                paddingLeft: '1px',
                                color: '#4A4A4A',
                            }}
                        >
                            Gallery Restricted
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                variant="body1"
                                style={{
                                    marginRight: '8px',
                                    color: galleryRestricted ? '#4A4A4A' : '#9E9E9E',
                                }}
                            >
                                {galleryRestricted ? 'Yes' : 'No'}
                            </Typography>
                            <IOSSwitch
                                checked={galleryRestricted}
                                onChange={(e) => setGalleryRestricted(e.target.checked)}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Document Required Switch */}
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px 20px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '8px',
                            backgroundColor: '#FFFFFF',
                        }}
                    >
                        <Typography
                            variant="body1"
                            style={{
                                paddingLeft: '1px',
                                color: '#4A4A4A',
                            }}
                        >
                            Document Required
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                variant="body1"
                                style={{
                                    marginRight: '8px',
                                    color: documentRequired ? '#4A4A4A' : '#9E9E9E',
                                }}
                            >
                                {documentRequired ? 'Yes' : 'No'}
                            </Typography>
                            <IOSSwitch
                                checked={documentRequired}
                                onChange={(e) => setDocumentRequired(e.target.checked)}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Document Number Required Switch */}
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px 20px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '8px',
                            backgroundColor: '#FFFFFF',
                        }}
                    >
                        <Typography
                            variant="body1"
                            style={{
                                paddingLeft: '1px',
                                color: '#4A4A4A',
                            }}
                        >
                            Document Number Required
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                variant="body1"
                                style={{
                                    marginRight: '8px',
                                    color: documentNumRequired ? '#4A4A4A' : '#9E9E9E',
                                }}
                            >
                                {documentNumRequired ? 'Yes' : 'No'}
                            </Typography>
                            <IOSSwitch
                                checked={documentNumRequired}
                                onChange={(e) => setDocumentNumRequired(e.target.checked)}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Document Expiry Required Switch */}
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px 20px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '8px',
                            backgroundColor: '#FFFFFF',
                        }}
                    >
                        <Typography
                            variant="body1"
                            style={{
                                paddingLeft: '1px',
                                color: '#4A4A4A',
                            }}
                        >
                            Document Expiry Date Required
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                variant="body1"
                                style={{
                                    marginRight: '8px',
                                    color: docExpiryRequired ? '#4A4A4A' : '#9E9E9E',
                                }}
                            >
                                {docExpiryRequired ? 'Yes' : 'No'}
                            </Typography>
                            <IOSSwitch
                                checked={docExpiryRequired}
                                onChange={(e) => setDocExpiryRequired(e.target.checked)}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>

            {/* Submit and Reset Buttons */}
            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{
                        width: '140px',
                        height: '50px',
                        textTransform: 'none',
                        fontSize: '16px',
                        backgroundColor: '#0065FF',
                        color: 'white',
                    }}
                >
                    {editMode ? 'Update' : 'Save'}
                </Button>
                <Button
                    variant="contained"
                    onClick={handleReset}
                    sx={{
                        width: '140px',
                        height: '50px',
                        textTransform: 'none',
                        fontSize: '16px',
                        backgroundColor: '#F0F0F0',
                        color: '#B0B0B0',
                    }}
                >
                    Reset
                </Button>
            </div>
            </Paper>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackbar(false)}
                message={snackbarMessage}
                action={
                    <Button color="primary" size="small" onClick={() => setOpenSnackbar(false)}>
                        Close
                    </Button>
                }
            />
        </div>
    );
};

export default AddDocument;